import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Paper,
} from '@mui/material';
import { formatFieldName, formatFieldValue } from '../../../utils/projectViewUtils';

const RevisionHistoryDialog = ({ open, onClose, selectedItem, revisions }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Revision History: {selectedItem?.title}</DialogTitle>
    <DialogContent>
      {revisions.length === 0 ? (
        <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
          No revision history available
        </Typography>
      ) : (
        <Box sx={{ mt: 2 }}>
          {revisions.map((revision) => (
            <Paper
              key={revision.id}
              variant="outlined"
              sx={{
                p: 2,
                mb: 2,
                borderLeft: 4,
                borderLeftColor:
                  revision.change_type === 'change_order_created' ? 'success.main' :
                  revision.change_type === 'approval_update' ? 'info.main' :
                  revision.change_type === 'cost_update' ? 'warning.main' :
                  'primary.main',
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                <Box>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {formatFieldName(revision.field_name)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Changed by {revision.first_name} {revision.last_name} ({revision.user_role})
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary">
                  {new Date(revision.created_at).toLocaleString()}
                </Typography>
              </Box>
              {revision.change_type === 'change_order_created' ? (
                <Box>
                  <Typography variant="body2" color="success.main">
                    {formatFieldValue(revision.field_name, revision.new_value)}
                  </Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" gap={2}>
                  <Box flex={1}>
                    <Typography variant="caption" color="text.secondary">From:</Typography>
                    <Typography variant="body2" sx={{ textDecoration: 'line-through', color: 'error.main' }}>
                      {formatFieldValue(revision.field_name, revision.old_value)}
                    </Typography>
                  </Box>
                  <Typography variant="h6" color="text.secondary">→</Typography>
                  <Box flex={1}>
                    <Typography variant="caption" color="text.secondary">To:</Typography>
                    <Typography variant="body2" fontWeight="bold" color="success.main">
                      {formatFieldValue(revision.field_name, revision.new_value)}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Paper>
          ))}
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default RevisionHistoryDialog;
